import Toastify from 'toastify-js'

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "linear-gradient(to right, rgba(var(--brand-1)), rgba(var(--brand-2)))" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify